export function buildPdfPreviewUrl(url: string): string {
	const hash = 'page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0';

	try {
		const parsed = new URL(url);
		parsed.hash = hash;
		return parsed.toString();
	} catch {
		const base = url.split('#')[0];
		return `${base}#${hash}`;
	}
}

export function isPdfAttachmentUrl(url?: string | null): boolean {
	if (!url) return false;

	try {
		return new URL(url).pathname.toLowerCase().endsWith('.pdf');
	} catch {
		return /\.pdf($|[?#])/i.test(url);
	}
}
